import React, { useMemo, useState, useEffect } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { useTranslation } from 'react-i18next'
import SiteHeaderDesktop from './SiteHeaderDesktop'
import SiteHeaderMobile from './SiteHeaderMobile'
import PropTypes from 'prop-types'

/**
 *
 * TODO: (in Contentful)
 *    in SE:
 *        All menu links begin with 'https://blok.se/'. To use Gatsby internal linking, change them to just have the link path e.g. /jamfor
 *        Change 'Bostäder' dropdown menu first item to '/bostader' instead of '/bostader/alla'
 */

const Header = ({ navConfig }) => {
  const { i18n } = useTranslation()
  const currentLocale = i18n.language

  const data = useStaticQuery(graphql`
    query HeaderQuery {
      allContentfulMainNavigation(filter: { isActive: { eq: true } }) {
        edges {
          node {
            styleOption
            appLoggedInButtonLabel
            appLoggedInButtonLink
            appLoginButtonLabel
            appLoginButtonLink
            appPriceValuationButtonLabel
            appPriceValuationButtonLink
            appStartSellingButtonLabel
            appStartSellingButtonLink
            country
            displayLanguageSwitcher
            hideLoginButton
            displayStartSellingButton
            languageSwitcherLabel
            leftNavigation {
              dropdownItems {
                apartmentFiltersCity
                apartmentsFilterType
                isListingsItem
                itemLabel
                itemLink
                showDividerAfter
                dropdownHeaderBefore
                id
              }
              isDropdownType
              itemLabel
              itemLink
              id
            }
            logo {
              gatsbyImageData(width: 200)
            }
            logoBlack {
              gatsbyImageData(width: 200)
            }
            phoneHelpText
            phoneHelpText2
            phoneNumber
            phoneTitle
            rightNavigation {
              dropdownItems {
                apartmentFiltersCity
                apartmentsFilterType
                isListingsItem
                itemLabel
                itemLink
                showDividerAfter
                dropdownHeaderBefore
                id
              }
              isDropdownType
              itemLabel
              itemLink
              id
            }
            node_locale
            isActive
          }
        }
      }
    }
  `)

  // Check if user is logged in
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    fetch(`${process.env.GATSBY_BLOK_APP_URL}/accounts/api/v1/logged-in`)
      .then((response) => response.text())
      .then((responseText) => {
        if (responseText === 'blokLoggedInCallback(true)') {
          setIsLoggedIn(true)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  const match = useMemo(
    () =>
      data.allContentfulMainNavigation.edges.find(
        ({ node }) =>
          node.country === process.env.GATSBY_COUNTRY &&
          node.node_locale === currentLocale
      ),
    [data]
  )

  // TODO No match is found in LEAD.
  if (!match) {
    return null
  }

  return (
    <>
      <SiteHeaderDesktop
        data={match.node}
        navConfig={navConfig}
        isLoggedIn={isLoggedIn}
        styleOption={match.node.styleOption}
      />
      <SiteHeaderMobile
        data={match.node}
        navConfig={navConfig}
        isLoggedIn={isLoggedIn}
        styleOption={match.node.styleOption}
      />
    </>
  )
}

Header.propTypes = {
  navConfig: PropTypes.object.isRequired,
}

export default Header
